var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20847)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#2AD4C5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20847)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#2AD4C5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20847)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20847)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3503 9.70015C18.2169 9.70015 17.5003 10.5501 17.2003 12.2501C17.1003 13.4501 17.1003 14.2335 17.2003 14.6001C17.4336 15.4668 18.0836 15.9001 19.1503 15.9001C19.8169 15.9001 20.2836 15.0835 20.5503 13.4501C20.6169 13.0501 20.7003 12.5668 20.8003 12.0001C20.9003 11.4001 20.8169 10.8668 20.5503 10.4001C20.3169 9.93348 19.9169 9.70015 19.3503 9.70015ZM17.2503 19.5001C16.1503 19.5001 15.4336 20.6001 15.1003 22.8001C14.9669 23.9335 15.0669 24.7835 15.4003 25.3501C15.7669 25.8835 16.3169 26.1501 17.0503 26.1501C17.7836 26.1501 18.4003 25.8835 18.9003 25.3501C19.4003 24.7835 19.7169 23.9501 19.8503 22.8501C20.0169 21.7501 19.8669 20.9168 19.4003 20.3501C18.9669 19.7835 18.2503 19.5001 17.2503 19.5001ZM20.0003 6.15015C22.0669 6.15015 23.6003 6.63348 24.6003 7.60015C25.6336 8.56681 26.0169 9.98348 25.7503 11.8501C25.4169 14.2168 24.0836 16.0001 21.7503 17.2001C24.2836 18.0001 25.3336 19.8001 24.9003 22.6001C24.6003 24.9668 23.6669 26.7835 22.1003 28.0501C20.7336 29.1501 18.8669 29.7001 16.5003 29.7001C12.9669 29.7001 10.8669 28.4168 10.2003 25.8501C9.96693 24.9501 9.93359 23.8001 10.1003 22.4001C10.3003 21.0001 10.8336 19.8835 11.7003 19.0501C12.5669 18.1835 13.6169 17.5668 14.8503 17.2001C12.7836 15.9668 11.9169 14.1835 12.2503 11.8501C12.5503 9.98348 13.4003 8.56681 14.8003 7.60015C16.2003 6.63348 17.9336 6.15015 20.0003 6.15015Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20847",
    x: 9.99609,
    y: 6.15015,
    width: 15.8359,
    height: 24.4867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20847",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20847",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound8);
export default __webpack_public_path__ + "static/media/motor_round_8.bff2e235c0d49744deae8410cd8de52c.svg";
export { ForwardRef as ReactComponent };